@if (controlHasError$ | async) {
  @if ({ valid: control.statusChanges | async}) {
    <div class="validation-message-container">
      <i class="fa fa-exclamation-triangle validation-message-container__icon" aria-hidden="true"></i>
      <div class="validation-message-wrapper">
        @for (entry of errorMessageMap | keyvalue; track entry.key) {
          @if (control.hasError(entry.key)) {
            <small>{{ entry.value | translate }}</small>
          }
        }
        @if (control.hasError('maxlength')) {
          <small>
            {{ 'VALIDATION_MESSAGE_MAXLENGTH' | translate : { characters: control.errors['maxlength'].requiredLength } }}
          </small>
        }
        @if (control.hasError('minlength')) {
          <small>
            {{ 'Minimum length is' | translate }} {{ control.errors['minlength'].requiredLength }} {{ 'characters' | translate }}
          </small>
        }
        @if (control.hasError('max')) {
          <small>
            {{ 'The number cannot exceed' | translate }} {{ control.errors['max'].max }}
          </small>
        }
        @if (control.hasError('min')) {
          <small>
            {{ 'The number cannot be below' | translate }} {{ control.errors['min'].min }}
          </small>
        }
        @if (control.hasError('minDate')) {
          <small>
            {{ ('Date must be after ' | translate) + control.errors['minDate'].min }}
          </small>
        }
        @if (control.hasError('maxDate')) {
          <small>
            {{ ('Date must be before ' | translate) + control.errors['maxDate'].max }}
          </small>
        }
        @if ((showPatternValidation$ | async) && control.hasError('pattern')) {
          <small>
            {{ 'Format not allowed' | translate }}
          </small>
        }
      </div>
    </div>
  }
}